import { configureStore, combineReducers } from '@reduxjs/toolkit';
import featuredPlayListSlice from '@/redux/featuredPlayListSlice';
import personalPlayListSlice from '@/redux/personalPlayListSlice';
import studioPlayListSlice from '@/redux/studioPlayListSlice';
import {
	featuredPlaylistApi,
	personalPlaylistApi,
	videoListApi,
	wishlistApi,
	combinePlaylistApi,
	studioPlaylistApi
} from '../service';
import authSlice from '@/redux/authSlice';
import videoSlice from '@/redux/videoSlice';
import sessionSlice from '@/redux/sessionSlice';

const appReducer = combineReducers({
	authState: authSlice,
	videoState: videoSlice,
	session: sessionSlice,
	featuredPlayListState: featuredPlayListSlice,
	personalPlayListState: personalPlayListSlice,
	studioPlayListState: studioPlayListSlice,
	[videoListApi.reducerPath]: videoListApi.reducer,
	[featuredPlaylistApi.reducerPath]: featuredPlaylistApi.reducer,
	[personalPlaylistApi.reducerPath]: personalPlaylistApi.reducer,
	[combinePlaylistApi.reducerPath]: combinePlaylistApi.reducer,
	[wishlistApi.reducerPath]: wishlistApi.reducer,
	[combinePlaylistApi.reducerPath]: combinePlaylistApi.reducer,
	[studioPlaylistApi.reducerPath]: studioPlaylistApi.reducer
});

export const store = configureStore({
	reducer: appReducer,
	middleware: getDefaltMiddleware =>
		getDefaltMiddleware({ serializableCheck: false }).concat([
			videoListApi.middleware,
			featuredPlaylistApi.middleware,
			personalPlaylistApi.middleware,
			wishlistApi.middleware,
			combinePlaylistApi.middleware,
			studioPlaylistApi.middleware
		])
});
